const styles = () => ({
  root: {
    height: '100% !important',
  },
  rightSideRootGrid: {
    backgroundColor: '#FDFCFC !important',
    borderLeft: '1px solid #E5E5E5 !important',
    paddingBottom: '24px !important',
  },
  rightSideSubGrid: {
    backgroundColor: '#FDFCFC !important',
    marginLeft: '121px !important',
    marginRight: '121px !important',
  },
})

export default styles
